<nav class="navbar">
  <div class="container">
    <div class="navbar-header">
      <a class="navbar-brand" href="#">NCommerce</a>
      <div class="navbar-links">
        <a class="navbar-link" href="#historia">História</a>
        <a class="navbar-link" href="#recursos">Recursos</a>
        <a class="navbar-link" href="#demonstracao">Demonstração</a>
        <a class="navbar-link" href="#contato">Contato</a>
        <a class="navbar-client" routerLink="/cliente">Área do Cliente</a>
        <a class="navbar-cta" href="#contato">Fale conosco</a>
      </div>
    </div>
  </div>
</nav>

<header class="hero">
  <div class="hero-content">
    <span class="hero-eyebrow">Sistema completo para restaurantes</span>
    <h1>Sua operação sob controle, do pedido à nota fiscal</h1>
    <p class="hero-subtitle">
      Chega de sistema travando, comanda sumindo e nota fiscal com erro. O NCommerce reúne pedidos, cozinha,
      caixa, delivery e nota fiscal em um só lugar &mdash; construído desde 2018 por quem já viveu a rotina de um restaurante.
    </p>
    <div class="hero-actions">
      <button class="btn btn-lg btn-primary" (click)="goToWhatsapp()">
        <fa-icon [icon]="faWhatsapp"></fa-icon> Falar com um especialista
      </button>
      <a class="btn btn-lg btn-outline" href="#recursos">Ver recursos</a>
    </div>
  </div>
</header>

<main class="content">
  <section id="historia" class="section history">
    <div class="container">
      <span class="section-eyebrow">Por que o NCommerce existe</span>
      <h2>História</h2>
      <p class="intro-head">
        Antes de criar o NCommerce, Ariel, dono de restaurante, lidava com diversos problemas com o sistema que utilizava.
        <b>Será que você também já passou por isso?</b>
      </p>

      <div class="problems-grid">
        <div class="problem-card">
          <div class="problem-icon"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
          <h3>O sistema travou</h3>
          <p>
            E isso sempre acontece no dia mais movimentado, né? Sempre em um Sábado à noite, no almoço de Domingo, ou pior,
            no dia das Mães. E você fica com a operação travada, e seu restaurante vai virando um caos.
          </p>
        </div>
        <div class="problem-card">
          <div class="problem-icon"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
          <h3>Não imprimiu o pedido</h3>
          <p>
            A impressora parou de funcionar e o sistema não avisou. E nós só descobrimos quando o cliente diz:
            "Tem UMA HORA que fizemos o pedido. Ele já está saindo?"
          </p>
        </div>
        <div class="problem-card">
          <div class="problem-icon"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
          <h3>As comandas "somem"</h3>
          <p>
            O garçom lançou o pedido, a cozinha preparou e o cliente está satisfeito e agora quer a conta. Mas cadê a
            comanda dele? Deu bug no sistema e a mesa desapareceu...
          </p>
        </div>
        <div class="problem-card">
          <div class="problem-icon"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
          <h3>Erro ao emitir nota fiscal</h3>
          <p>
            Você tem que inserir os dados fiscais de todos os produtos que você vende. É muito complicado preencher
            certinho todos os campos... NCM, CEST, CFOP... e por causa de um erro na hora de preencher, você não
            consegue emitir a nota e o sistema deixa você travado.
          </p>
        </div>
        <div class="problem-card">
          <div class="problem-icon"><fa-icon [icon]="faTriangleExclamation"></fa-icon></div>
          <h3>Você não comprou o Módulo NFCe</h3>
          <p>
            Você encontrou um sistema bem baratinho, né? Aí você compra ele e faz o plano anual (pra segurar você).
            Mas na hora de emitir nota fiscal, você descobre que tem que pagar mais. Ao querer gerar um menu digital,
            tem que pagar MAIS. Quer site de delivery? Pague MAAAIS. Afinal, você não leu que pra ter tudo isso, tinha
            que fazer o plano PREMIUM PRO MAX ULTRA por 5x o valor "inicial". E se não quiser pagar esse absurdo, azar
            o seu, pois você fez o plano anual e clicou no "Aceito os termos e condições" de 12 páginas.
          </p>
        </div>
      </div>

      <p class="intro-foot">
        Ao vivenciar e ficar frustrado com tantos problemas e tantos prejuízos, Ariel colocou seus conhecimentos e
        experiência em prática, e decidiu criar seu próprio sistema, e resolver <b>De Uma Vez Por Todas</b> todos esses
        problemas. Desde 2018, Ariel vem construindo e aprimorando diariamente o NCommerce.
      </p>
    </div>
  </section>

  <section id="recursos" class="section resources">
    <div class="container">
      <span class="section-eyebrow">O que está incluso</span>
      <h2>Recursos</h2>
      <p class="resources-intro">Para cada problema, uma solução! Veja o que o NCommerce oferece!</p>

      <div class="table-card">
        <table class="table table-hover features-table">
          <thead>
            <tr>
              <th>Funcionalidade</th>
              <th>Plano Grátis</th>
              <th>Plano Essencial</th>
              <th>Plano Completo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Pedidos lançados por mês</td>
              <td class="limit">até 500</td>
              <td>Ilimitado</td>
              <td>Ilimitado</td>
            </tr>
            <tr>
              <td>Suporte dedicado além do horário comercial</td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Lançar pedidos via celular/tablet/PC</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Controle de estoque</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Histórico de preço dos insumos</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Controle de caixa</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Relatório financeiro</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Emissão de NFC-e e NF-e (Nota Maior)</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Menu Digital</td>
              <td class="limit">100 visitas/mês</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Site de Delivery</td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Site de Reservas</td>
              <td class="limit">50 visitas/mês</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Site de Avaliação PERSONALIZÁVEL</td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Gerador de QR Code de PIX</td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Confirmações via Whatsapp (Pedidos/Reservas)</td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
            <tr>
              <td>Pedido em tablet/celular de autoatendimento</td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-no" [icon]="faXmark"></fa-icon></td>
              <td><fa-icon class="icon-yes" [icon]="faCircleCheck"></fa-icon></td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="resources-foot">
        Como você pode ver, o plano essencial já inclui praticamente tudo o que seu restaurante precisa, sem precisar
        comprar módulos adicionais. Apenas algumas funcionalidades que demandam um custo maior são colocadas no plano
        Premium. Abaixo, você tem acesso aos valores cobrados:
      </p>

      <div class="pricing-grid">

        <div class="pricing-card">

          <h3>Plano Grátis</h3>

          <div class="price"><span class="price-currency">R$</span>0<span class="price-period">/mês</span></div>

          <p class="pricing-desc">Para começar: até 500 pedidos por mês, com suporte automatizado e por e-mail.</p>

          <a class="btn btn-outline" routerLink="/cadastro" [queryParams]="{ plano: 'free' }">Começar grátis</a>

        </div>
        <div class="pricing-card">
          <h3>Plano Essencial</h3>
          <div class="price"><span class="price-currency">R$</span>600<span class="price-period">/mês</span></div>
          <p class="pricing-desc">Tudo o que seu restaurante precisa para operar sem dor de cabeça.</p>
          <a class="btn btn-outline" routerLink="/cadastro" [queryParams]="{ plano: 'essencial' }">Escolher plano</a>
        </div>
        <div class="pricing-card pricing-card-featured">
          <span class="pricing-badge"><fa-icon [icon]="faStar"></fa-icon> Mais completo</span>
          <h3>Plano Completo</h3>
          <div class="price"><span class="price-currency">R$</span>900<span class="price-period">/mês</span></div>
          <p class="pricing-desc">Inclui autoatendimento e confirmações automáticas via Whatsapp.</p>
          <a class="btn btn-primary" routerLink="/cadastro" [queryParams]="{ plano: 'completo' }">Escolher plano</a>
        </div>
      </div>
      <div class="pricing-extra">
        <div><b>Instalação e Configuração do Sistema:</b> R$600,00</div>
        <div><b>Demais serviços:</b> A combinar</div>
      </div>
    </div>
  </section>

  <section id="demonstracao" class="section demo">
    <div class="container">
      <span class="section-eyebrow">Veja funcionando</span>
      <h2>Demonstração</h2>
      <p class="demo-head">A seguir, veja esta playlist com alguns exemplos de utilização do sistema:</p>
      <div class="video-demo">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/Dm5NFjeGJXA?si=AwEcop2-0Zd57kT6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </section>

  <section id="contato" class="section contact">
    <div class="container">
      <h2>Contato</h2>
      <p class="contact-head">
        Quer ter o controle do seu comércio NA SUA MÃO? Então vamos conversar! Estou aqui para tirar suas dúvidas:
      </p>
      <button class="btn btn-lg btn-whatsapp" (click)="goToWhatsapp()">
        <fa-icon [icon]="faWhatsapp"></fa-icon> Falar no Whatsapp
      </button>
    </div>
  </section>
</main>

<footer class="site-footer">
  <div class="container footer-content">
    <span class="navbar-brand">NCommerce</span>
    <nav class="footer-links">
      <a routerLink="/privacidade">Política de Privacidade</a>
      <a routerLink="/termos">Termos de Uso</a>
    </nav>
    <span>&copy; {{ currentYear }} NCommerce — Bonome Software Ltda. Todos os direitos reservados.</span>
  </div>
</footer>
